var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['square', { selected: _vm.isSelected}],style:({ backgroundColor: _vm.isSelected ? _vm.selectedColor : _vm.color }),on:{"click":_vm.toggleSelect}},[(_vm.isSelected)?_c('span',{staticClass:"checkmark"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }